import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { useToasts } from 'react-toast-notifications'

import { WarningModal } from '../../../ui'

export const DeleteFileModal = ({
  file,
  submitResponse,
  isVisible,
  setModalVisibility,
  setFileToDelete,
}) => {
  const { addToast } = useToasts()
  const [backEndErrors, setBackEndErrors] = React.useState({})

  const DeleteMedia = async id => {
    axios({
      method: 'post',
      url: `/v1/candidates/media/${id}/delete`,
    })
      .then(response => {
        if (response.data.success) {
          submitResponse(file, 'delete')
          setModalVisibility(false)
          setFileToDelete({})
          addToast('Media deleted successfully', { appearance: 'success' })
        } else {
          addToast('Error deleting media, please try again', {
            appearance: 'error',
          })
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          setBackEndErrors(error.response.data.errors)
        } else {
          setBackEndErrors(error.response.data.error)
          addToast(`Error deleting media, please try again`, {
            appearance: 'error',
          })
        }
        addToast('Error deleting media, please try again', {
          appearance: 'error',
        })
      })
  }

  return (
    <WarningModal
      isVisible={isVisible}
      heading="Delete file?"
      closeFunc={() => {
        setModalVisibility(false)
        setFileToDelete({})
      }}
      submitButtonText="Delete file"
      submitFunc={() => DeleteMedia(file.id)}
      backEndErrors={backEndErrors}
    >
      <b>{file.title}</b> will no longer exist and will no longer be
      downloadable
    </WarningModal>
  )
}

DeleteFileModal.propTypes = {
  file: PropTypes.object.isRequired,
  submitResponse: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  setModalVisibility: PropTypes.func.isRequired,
  setFileToDelete: PropTypes.func.isRequired,
}
